// extracted by mini-css-extract-plugin
export default {"medicine-wise-stock-transfer-report-container":"MedicineWiseStockTransferReport_medicine-wise-stock-transfer-report-container__QyH-j"};